export function helpSection() {
    let
        list = $(".help-section-list"),
        listItems = list.find("> li");

    list.on("click", "h4, .h4, .help-item-title", function () {
        $(this).closest("li").toggleClass("open").siblings().removeClass("open");
    });

    if ($("body").hasClass("no-touch")) {
        list.on("mouseleave", function () {
            listItems.removeClass("hover hover-left hover-right");
        });

        listItems.on("mouseenter", function () {
            let item = $(this);

            item.siblings().removeClass("hover hover-left hover-right");
            item.prev().addClass("hover-left");
            item.next().addClass("hover-right");
            item.removeClass("hover-left hover-right").addClass("hover");
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/helpSection.js